/**
 * ===============================================================================================================
 * ===============================================================================================================
 * CUSTOM CODE BY BYTES
 * ===============================================================================================================
 * ===============================================================================================================
*/

/**
 * Custom Klavito Scripts
*/
// Move Labels below inputs
setTimeout(function() {
  const inputs = document.querySelectorAll('.klaviyo-form label + input');
  inputs.forEach(function(input, index) {
    console.log(inputs);
    const klaviyoFormObserver = new MutationObserver( (mutationList) => {
      for(var mutation of mutationList) {
        if( mutation.attributeName = 'class' ) {
          const input = mutation.target;
          if( input.classList.contains('is-filled') ) {
            input.parentElement.querySelector('label').classList.add('input-is-filled');
          }
        }
      }
    } );
    klaviyoFormObserver.observe( input, { attributes: true } );
  });
}, 1000);
